import { PROJECT_TYPE_CODE } from '..';
import { ProductLineCodesTypes } from '../../business-lines/product-lines-codes';
import { ShippingConditionsCodesTypes } from '../../shipping-conditions/shipping-conditions-codes';

export interface GetProjectsRequest {
  // required
  productLineCode: ProductLineCodesTypes;

  // optional
  projectTypeCode?: PROJECT_TYPE_CODE;
  shippingConditionCode?: ShippingConditionsCodesTypes;
  customerCode?: string;

  // offset / limit
  page?: number;
  fetch?: number;
}
